import { render, staticRenderFns } from "./boleto-bar-code-loader.vue?vue&type=template&id=5c05edc8&scoped=true&"
import script from "./boleto-bar-code-loader.vue?vue&type=script&lang=js&"
export * from "./boleto-bar-code-loader.vue?vue&type=script&lang=js&"
import style0 from "./boleto-bar-code-loader.vue?vue&type=style&index=0&id=5c05edc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c05edc8",
  null
  
)

export default component.exports